// extracted by mini-css-extract-plugin
export var clickThrough = "_yo-2";
export var fallback = "_yo-5";
export var frame = "_yo-3";
export var frameCell = "_yo-1";
export var overlay = "_yo-4";
export var wrapper = "_yo-0";